import React from 'react';
import './end-list-view.scss';

interface EndListViewProps {
  message?: string;
  className?: string;
}

export const EndListView: React.FC<EndListViewProps> = ({
  message = 'You have reached to the end of the page',
  className = '',
}) => {
  return (
    <div className={`end-reached-text ${className} font-medium`}>{message}</div>
  );
};
